import React, { PureComponent } from 'react';

class ToolbarSpacer extends PureComponent {
  render() {
    return <div style={{ flex: '1 1 auto' }} {...this.props} />;
  }
}

export default ToolbarSpacer;
